{
  "collapse": "Réduire",
  "expand": "Développer"
}
